import React, { useState, useEffect } from "react";
import "../artikel/artikel.css";
import moment from "moment";
import axios from "axios";
import API_URL from "../../ApiUrl";
import { Link } from "react-router-dom";

const ArtikelItem = ({ data, kategori_artikel }) => {
  const [selectedKategori, setSelectedKategori] = useState(null);
  const [dataArtikelKategori, setDataArtikelKategori] = useState([]);

  useEffect(() => {
    getArtikelKategori();
  }, []);

  const getArtikelKategori = async () => {
    try {
      const response = await axios.get(
        `${API_URL.superStudent}/website/artikel-kategori`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );

      const kategoriData = response.data.data;

      const kategoriWithCount = kategoriData.map((kategori) => {
        const count = data.filter(
          (artikel) =>
            artikel.kategori.code_artikel_kategori ===
              kategori.code_artikel_kategori && artikel.is_publish
        ).length;
        return {
          ...kategori,
          publishedArticles: count,
        };
      });

      setDataArtikelKategori(kategoriWithCount);
    } catch (error) {
      console.error("Error fetching artikel kategori: ", error);
    }
  };

  const handleKategoriChange = (kategoriId) => {
    setSelectedKategori(kategoriId);
  };

  const showAllArtikel = () => {
    setSelectedKategori(null);
  };

  const filteredData = selectedKategori
    ? data.filter(
        (d) =>
          d.kategori.code_artikel_kategori === selectedKategori && d.is_publish
      )
    : data.filter((d) => d.is_publish);

  // Extract the newest article for the Hero section, rest for Grid
  const heroArticle = filteredData.length > 0 ? filteredData[0] : null;
  const gridArticles = filteredData.length > 1 ? filteredData.slice(1) : [];

  const shortenText = (text, maxLength) => {
    if (!text) return "";
    // Strip HTML tags for clean description excerpt
    const cleanText = text.replace(/<[^>]*>?/gm, '');
    if (cleanText.length > maxLength) {
      return cleanText.substring(0, maxLength) + "...";
    }
    return cleanText;
  };

  return (
    <div className="artikel-page-wrapper">
      {/* Background Decorative Shapes */}
      <div className="artikel-bg-blob-1"></div>
      <div className="artikel-bg-blob-2"></div>
      <div className="artikel-bg-blob-3"></div>

      <div className="container artikel-content-container">
        <h1 className="artikel-page-title animate__animated animate__fadeInDown">
          Blogs &amp; Articles
        </h1>

        {/* Featured Article (Hero) */}
        {heroArticle && (
          <div className="artikel-hero-card animate__animated animate__fadeInUp">
            <div className="artikel-hero-img-col">
              <img src={heroArticle.image} alt={heroArticle.judul} className="artikel-hero-img" />
            </div>
            <div className="artikel-hero-content-col">
              <div className="badge-outline-red">{heroArticle.kategori?.kategori || "Umum"}</div>
              <h2 className="artikel-hero-title">{heroArticle.judul}</h2>
              <p className="artikel-hero-desc">
                {shortenText(heroArticle.isi, 150)}
              </p>
              <Link to={`/artikeldetail/${heroArticle.slug}`} className="btn-red-pill">
                Selengkapnya
              </Link>
            </div>
          </div>
        )}

        {/* Category Filters */}
        <div className="artikel-filter-wrapper animate__animated animate__fadeIn">
          <button 
            className={`filter-pill ${selectedKategori === null ? "active" : ""}`}
            onClick={showAllArtikel}
          >
            Semua Artikel
          </button>
          {kategori_artikel.map((k, i) => (
            <button
              key={i}
              className={`filter-pill ${selectedKategori === k.code_artikel_kategori ? "active" : ""}`}
              onClick={() => handleKategoriChange(k.code_artikel_kategori)}
            >
              {k.kategori}
            </button>
          ))}
        </div>

        {/* Article Grid */}
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 pb-5">
          {filteredData.length === 0 ? (
            <div className="col-12 text-center py-5">
              <p>Tidak ada artikel yang ditemukan</p>
            </div>
          ) : (
            gridArticles.map((d, i) => (
              <div className="col animate__animated animate__fadeInUp" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="artikel-card-modern">
                  <div className="artikel-card-img-wrap">
                    <div className="artikel-badge-float">{d.kategori?.kategori || "Umum"}</div>
                    <img
                      src={d.image}
                      className="artikel-card-img"
                      alt={d.judul}
                    />
                  </div>
                  <div className="artikel-card-body">
                    <h3 className="artikel-card-title">{d.judul}</h3>
                    <p className="artikel-card-desc">
                      {shortenText(d.isi, 120)}
                    </p>
                    <Link to={`/artikeldetail/${d.slug}`} className="btn-red-pill mt-auto">
                      Selengkapnya
                    </Link>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
};

export default ArtikelItem;
